// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   Paper,
//   TextField,
//   IconButton,
//   InputAdornment,
//   CircularProgress,
//   Alert,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   MenuItem,
//   useMediaQuery,
// } from "@mui/material";
// import { useParams, useNavigate, useLocation } from "react-router-dom";
// import { Icon } from "../../icons";
// import { COLORS, TYPOGRAPHY } from "../../constants/color";
// import axios from "axios";
// import { useAuth } from "../../context/authContext";
// import { url } from "../../constants/url";
// import AppToast from "../../components/AppToast";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { format } from "date-fns";

// export default function EditWPR() {
//   const { projectId } = useParams();
//   const { token, userData } = useAuth();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const isMobile = useMediaQuery("(max-width: 768px)");

//   // Get week data from navigation state
//   const { weekType, weekStartDate: initialWeekStartDate, weekEndDate: initialWeekEndDate } = location.state || {};

//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [project, setProject] = useState(null);
//   const [companies, setCompanies] = useState([]);
//   const [selectedCompany, setSelectedCompany] = useState("");
  
//   // Week date state
//   const [weekStartDate, setWeekStartDate] = useState(initialWeekStartDate ? new Date(initialWeekStartDate) : null);
//   const [weekEndDate, setWeekEndDate] = useState(initialWeekEndDate ? new Date(initialWeekEndDate) : null);
//   const [showDatePicker, setShowDatePicker] = useState(false);
  
//   // Toast state
//   const [toast, setToast] = useState({
//     open: false,
//     type: "success",
//     title: "",
//     message: "",
//   });
  
//   // Week data state
//   const [weekData, setWeekData] = useState([]);
//   const [wprId, setWprId] = useState(null);
  
//   // Add/Edit entry form state
//   const [newEntry, setNewEntry] = useState({
//     targetedActivity: "",
//     contractorVendor: "",
//     details: "",
//     materialMachineryRequirements: "",
//     supportNeeded: "",
//     remarks: "",
//   });
  
//   const [activeDay, setActiveDay] = useState(null);
//   const [editingEntryId, setEditingEntryId] = useState(null);
//   const [saving, setSaving] = useState(false);
//   const [deleteDialog, setDeleteDialog] = useState({
//     open: false,
//     entryId: null,
//     dayIndex: null,
//     entryIndex: null,
//   });

//   const COLS = {
//     week: "160px",
//     activity: 1,
//     details: 1.4,
//     material: 1.3,
//     support: 1.1,
//     remark: 1.2,
//     action: "40px",
//   };

//   // Format date function
//   const formatDate = (date) => {
//     if (!date) return "";
//     const d = new Date(date);
//     const day = d.getDate();
//     const suffix = getDaySuffix(day);
//     const month = d.toLocaleString('default', { month: 'short' });
//     const year = d.getFullYear().toString().slice(-2);
//     const dayName = d.toLocaleString('default', { weekday: 'long' });
    
//     return `${dayName} ${day}${suffix} ${month} '${year}`;
//   };

//   // Format date for week column (Monday 5th Jan '26)
//   const formatDateForWeekColumn = (date) => {
//     if (!date) return "";
//     const d = new Date(date);
//     const day = d.getDate();
//     const suffix = getDaySuffix(day);
//     const month = d.toLocaleString('default', { month: 'short' });
//     const year = d.getFullYear().toString().slice(-2);
//     const dayName = d.toLocaleString('default', { weekday: 'long' });
    
//     return `${dayName} ${day}${suffix} ${month} '${year}`;
//   };

//   // Format date for week header (DD/MM/YY - DD/MM/YY)
//   const formatDateForWeekHeader = (date) => {
//     if (!date) return "";
//     const d = new Date(date);
//     return format(d, "dd/MM/yy");
//   };

//   const getDaySuffix = (day) => {
//     if (day >= 11 && day <= 13) return 'th';
//     switch (day % 10) {
//       case 1: return 'st';
//       case 2: return 'nd';
//       case 3: return 'rd';
//       default: return 'th';
//     }
//   };

//   // Fetch project data and WPR data
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         setError(null);
        
//         const config = {
//           headers: {
//             Authorization: token ? `Bearer ${token}` : undefined,
//           },
//         };
        
//         // Fetch project details
//         const projectResponse = await axios.get(
//           `${url}/api/inhouse-projects/fetch-by/${projectId}`,
//           config
//         );
        
//         if (projectResponse.data.project) {
//           setProject(projectResponse.data.project);
          
//           // Fetch companies for PMC dropdown
//           const companiesResponse = await axios.get(
//             `${url}/api/company/fetch`,
//             config
//           );
          
//           if (companiesResponse.data.data) {
//             setCompanies(companiesResponse.data.data);
//             // Select first company by default
//             if (companiesResponse.data.data.length > 0) {
//               setSelectedCompany(companiesResponse.data.data[0]._id);
//             }
//           }
          
//           // If week dates are provided, fetch WPR data
//           if (weekStartDate && weekEndDate) {
//             await fetchWPRData();
//           } else {
//             setLoading(false);
//           }
//         } else {
//           setError("Project not found");
//           setLoading(false);
//         }
//       } catch (err) {
//         console.error("Error fetching data:", err);
//         setError("Failed to load project data. Please try again.");
//         setLoading(false);
//       }
//     };
    
//     if (projectId && token) {
//       fetchData();
//     }
//   }, [projectId, token, weekStartDate, weekEndDate]);

//   // Fetch WPR data for the selected week
//  // Fetch WPR data for the selected week
// const fetchWPRData = async () => {
//   try {
//     const config = {
//       headers: {
//         Authorization: token ? `Bearer ${token}` : undefined,
//       },
//     };
    
//     console.log("Fetching WPR data for week:", {
//       start: weekStartDate,
//       end: weekEndDate,
//       startStr: format(weekStartDate, "yyyy-MM-dd"),
//       endStr: format(weekEndDate, "yyyy-MM-dd")
//     });
    
//     // Fetch all WPRs for this project
//     const wprResponse = await axios.get(
//       `${url}/api/wpr/fetch-by-project/${projectId}`,
//       config
//     );
    
//     console.log("All WPRs received:", wprResponse.data.wprs);
    
//     if (wprResponse.data.wprs && wprResponse.data.wprs.length > 0) {
//       // Find WPR for the selected week
//       const weekStartStr = format(weekStartDate, "yyyy-MM-dd");
//       const weekEndStr = format(weekEndDate, "yyyy-MM-dd");
      
//       console.log("Looking for WPR with dates:", weekStartStr, "to", weekEndStr);
      
//       const existingWPR = wprResponse.data.wprs.find(wpr => {
//         if (!wpr.weekStartDate || !wpr.weekEndDate) return false;
        
//         const wprStart = format(new Date(wpr.weekStartDate), "yyyy-MM-dd");
//         const wprEnd = format(new Date(wpr.weekEndDate), "yyyy-MM-dd");
        
//         console.log("Checking WPR:", {
//           wprTitle: wpr.title,
//           wprStart: wprStart,
//           wprEnd: wprEnd,
//           matches: wprStart === weekStartStr && wprEnd === weekEndStr
//         });
        
//         return wprStart === weekStartStr && wprEnd === weekEndStr;
//       });
      
//       console.log("Found existing WPR:", existingWPR);
      
//       if (existingWPR) {
//         setWprId(existingWPR._id);
//         console.log("WPR daily entries:", existingWPR.dailyEntries);
//         // Generate week data with existing entries
//         generateWeekDataWithEntries(existingWPR.dailyEntries || []);
//       } else {
//         console.log("No existing WPR found for this week");
//         // No existing WPR for this week, generate empty week data
//         generateWeekData();
//       }
//     } else {
//       console.log("No WPRs exist for this project");
//       // No WPRs exist for this project, generate empty week data
//       generateWeekData();
//     }
//   } catch (err) {
//     console.error("Error fetching WPR data:", err);
//     console.error("Error details:", err.response?.data);
//     // Generate empty week data on error
//     generateWeekData();
//   } finally {
//     setLoading(false);
//   }
// };

//   // Generate week data with existing entries
// // Generate week data with existing entries
// const generateWeekDataWithEntries = (dailyEntries) => {
//   console.log("Generating week data with entries:", dailyEntries);
//   console.log("Week start date:", weekStartDate);
  
//   const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
//   const weekDataArray = [];
  
//   const currentDate = new Date(weekStartDate);
  
//   for (let i = 0; i < 6; i++) {
//     const date = new Date(currentDate);
//     date.setDate(currentDate.getDate() + i);
    
//     // Format date for comparison (YYYY-MM-DD)
//     const dateStr = format(date, "yyyy-MM-dd");
//     console.log(`Day ${i} (${days[i]}):`, dateStr);
    
//     // Find entries for this specific date - compare using date strings
//     const dayEntry = dailyEntries.find(entry => {
//       if (!entry.date) return false;
      
//       const entryDate = new Date(entry.date);
//       const entryDateStr = format(entryDate, "yyyy-MM-dd");
      
//       console.log(`  Checking entry: day=${entry.day}, date=${entryDateStr}`);
      
//       // Match by both day name AND date string
//       return entry.day === days[i] && entryDateStr === dateStr;
//     });
    
//     console.log(`  Found day entry:`, dayEntry);
    
//     weekDataArray.push({
//       day: days[i],
//       date: date,
//       formattedDate: formatDate(date),
//       entries: dayEntry?.entries?.map(entry => ({
//         _id: entry._id,
//         targetedActivity: entry.targetedActivity || "",
//         contractorVendor: entry.contractorVendor || "",
//         details: entry.details || "",
//         materialMachineryRequirements: entry.materialMachineryRequirements || "",
//         supportNeeded: entry.supportNeeded || "",
//         remarks: entry.remarks || "",
//       })) || [],
//     });
//   }
  
//   console.log("Generated week data:", weekDataArray);
//   setWeekData(weekDataArray);
// };

//   // Generate empty week data structure
//   const generateWeekData = () => {
//     const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
//     const weekDataArray = [];
    
//     const currentDate = new Date(weekStartDate);
    
//     for (let i = 0; i < 6; i++) {
//       const date = new Date(currentDate);
//       date.setDate(currentDate.getDate() + i);
      
//       weekDataArray.push({
//         day: days[i],
//         date: date,
//         formattedDate: formatDate(date),
//         entries: [],
//       });
//     }
    
//     setWeekData(weekDataArray);
//   };

//   // Handle week date selection (force Monday selection)
//   const handleWeekDateSelect = (date) => {
//     if (!date) return;
    
//     // Ensure selected date is a Monday
//     const selectedDate = new Date(date);
//     const dayOfWeek = selectedDate.getDay();
//     const monday = new Date(selectedDate);
    
//     // Adjust to Monday (day 1 in JS Date is Sunday = 0, Monday = 1)
//     if (dayOfWeek === 0) {
//       monday.setDate(selectedDate.getDate() - 6); // Sunday goes to previous Monday
//     } else if (dayOfWeek > 1) {
//       monday.setDate(selectedDate.getDate() - (dayOfWeek - 1));
//     }
    
//     // Calculate Saturday (6 days after Monday)
//     const saturday = new Date(monday);
//     saturday.setDate(monday.getDate() + 5);
    
//     setWeekStartDate(monday);
//     setWeekEndDate(saturday);
//     setShowDatePicker(false);
    
//     showToast("success", "Week Selected", `Week: ${formatDateForWeekHeader(monday)} - ${formatDateForWeekHeader(saturday)}`);
//   };

//   // Handle adding new entry
//   const handleAddEntry = async () => {
//     if (!activeDay) return;
    
//     // Validate required fields
//     // if (!newEntry.targetedActivity || !newEntry.contractorVendor || 
//     //     !newEntry.details || !newEntry.materialMachineryRequirements || 
//     //     !newEntry.supportNeeded) {
//     //   showToast("error", "Validation Error", "Please fill all required fields");
//     //   return;
//     // }
    
//     try {
//       setSaving(true);
      
//       const config = {
//         headers: {
//           Authorization: token ? `Bearer ${token}` : undefined,
//           "Content-Type": "application/json",
//         },
//       };
      
//       // Find the day index
//       const dayIndex = weekData.findIndex(day => day.formattedDate === activeDay);
//       if (dayIndex === -1) {
//         showToast("error", "Error", "Day not found");
//         return;
//       }
      
//       // If editing existing entry
//       if (editingEntryId && wprId) {
//         await updateExistingEntry(dayIndex);
//       } else {
//         // Add new entry
//         await addNewEntry(dayIndex);
//       }
//     } catch (err) {
//       console.error("Error saving entry:", err);
//       showToast("error", "Error", err.response?.data?.message || "Failed to save entry");
//     } finally {
//       setSaving(false);
//     }
//   };

//   // Add new entry
//   const addNewEntry = async (dayIndex) => {
//     const config = {
//       headers: {
//         Authorization: token ? `Bearer ${token}` : undefined,
//         "Content-Type": "application/json",
//       },
//     };
    
//     const weekStartStr = weekStartDate.toISOString().split('T')[0];
//     const weekEndStr = weekEndDate.toISOString().split('T')[0];
    
//     // Get or create WPR
//     let currentWprId = wprId;
    
//     if (!currentWprId) {
//       // Create new WPR
//       const wprData = {
//         projectId,
//         title: `WPR - ${formatDateForWeekHeader(weekStartDate)} to ${formatDateForWeekHeader(weekEndDate)}`,
//         weekStartDate: weekStartStr,
//         weekEndDate: weekEndStr,
//         dailyEntries: [],
//       };
      
//       const wprResponse = await axios.post(
//         `${url}/api/wpr/add`,
//         wprData,
//         config
//       );
      
//       if (wprResponse.data.data?._id) {
//         currentWprId = wprResponse.data.data._id;
//         setWprId(currentWprId);
//       }
//     }
    
//     if (currentWprId) {
//       const selectedDay = weekData[dayIndex];
      
//       const dailyEntryData = {
//         day: selectedDay.day,
//         date: selectedDay.date.toISOString().split('T')[0],
//         entries: [{
//           targetedActivity: newEntry.targetedActivity,
//           contractorVendor: newEntry.contractorVendor,
//           details: newEntry.details,
//           materialMachineryRequirements: newEntry.materialMachineryRequirements,
//           supportNeeded: newEntry.supportNeeded,
//           remarks: newEntry.remarks || "",
//         }]
//       };
      
//       const entryResponse = await axios.patch(
//         `${url}/api/wpr/add/${currentWprId}/daily-entry`,
//         dailyEntryData,
//         config
//       );
      
//       if (entryResponse.data.wpr) {
//         // Update local state with the new entry ID from backend
//         const updatedWeekData = [...weekData];
//         const newEntryFromBackend = entryResponse.data.wpr.dailyEntries
//           ?.find(de => de.day === selectedDay.day && new Date(de.date).toDateString() === selectedDay.date.toDateString())
//           ?.entries?.slice(-1)[0]; // Get the last added entry
        
//         if (updatedWeekData[dayIndex].entries) {
//           updatedWeekData[dayIndex].entries.push({
//             ...newEntry,
//             _id: newEntryFromBackend?._id || Date.now().toString()
//           });
//         } else {
//           updatedWeekData[dayIndex].entries = [{
//             ...newEntry,
//             _id: newEntryFromBackend?._id || Date.now().toString()
//           }];
//         }
//         setWeekData(updatedWeekData);
        
//         // Reset form
//         resetForm();
        
//         showToast("success", "Success", "Entry added successfully!");
//       }
//     }
//   };

//   // Update existing entry
//   const updateExistingEntry = async (dayIndex) => {
//     const config = {
//       headers: {
//         Authorization: token ? `Bearer ${token}` : undefined,
//         "Content-Type": "application/json",
//       },
//     };
    
//     const updateData = {
//       targetedActivity: newEntry.targetedActivity,
//       contractorVendor: newEntry.contractorVendor,
//       details: newEntry.details,
//       materialMachineryRequirements: newEntry.materialMachineryRequirements,
//       supportNeeded: newEntry.supportNeeded,
//       remarks: newEntry.remarks || "",
//     };
    
//     const updateResponse = await axios.put(
//       `${url}/api/wpr/update/${wprId}/entry/${editingEntryId}`,
//       updateData,
//       config
//     );
    
//     if (updateResponse.data.wpr) {
//       // Update local state
//       const updatedWeekData = [...weekData];
//       const entryIndex = updatedWeekData[dayIndex].entries.findIndex(entry => entry._id === editingEntryId);
      
//       if (entryIndex !== -1) {
//         updatedWeekData[dayIndex].entries[entryIndex] = {
//           ...updatedWeekData[dayIndex].entries[entryIndex],
//           ...newEntry
//         };
//         setWeekData(updatedWeekData);
//       }
      
//       // Reset form
//       resetForm();
      
//       showToast("success", "Success", "Entry updated successfully!");
//     }
//   };

//   // Handle deleting entry
//   const handleDeleteEntry = async () => {
//     const { dayIndex, entryIndex, entryId } = deleteDialog;
    
//     try {
//       setSaving(true);
      
//       const config = {
//         headers: {
//           Authorization: token ? `Bearer ${token}` : undefined,
//         },
//       };
      
//       // Delete from backend if we have wprId and entryId
//       if (wprId && entryId && !entryId.startsWith('temp-')) {
//         await axios.delete(
//           `${url}/api/wpr/delete/${wprId}/entry/${entryId}`,
//           config
//         );
//       }
      
//       // Remove from local state
//       const updatedWeekData = [...weekData];
//       updatedWeekData[dayIndex].entries.splice(entryIndex, 1);
//       setWeekData(updatedWeekData);
      
//       setDeleteDialog({ open: false, entryId: null, dayIndex: null, entryIndex: null });
//       showToast("success", "Success", "Entry deleted successfully!");
//     } catch (err) {
//       console.error("Error deleting entry:", err);
//       showToast("error", "Error", "Failed to delete entry");
//     } finally {
//       setSaving(false);
//     }
//   };

//   // Handle edit entry click
//   const handleEditEntry = (dayIndex, entryIndex) => {
//     const entry = weekData[dayIndex].entries[entryIndex];
//     setActiveDay(weekData[dayIndex].formattedDate);
//     setEditingEntryId(entry._id);
//     setNewEntry({
//       targetedActivity: entry.targetedActivity || "",
//       contractorVendor: entry.contractorVendor || "",
//       details: entry.details || "",
//       materialMachineryRequirements: entry.materialMachineryRequirements || "",
//       supportNeeded: entry.supportNeeded || "",
//       remarks: entry.remarks || "",
//     });
//   };

//   // Reset form
//   const resetForm = () => {
//     setActiveDay(null);
//     setEditingEntryId(null);
//     setNewEntry({
//       targetedActivity: "",
//       contractorVendor: "",
//       details: "",
//       materialMachineryRequirements: "",
//       supportNeeded: "",
//       remarks: "",
//     });
//   };

//   // Cancel edit/add
//   const handleCancel = () => {
//     resetForm();
//   };

//   // Show toast function
//   const showToast = (type, title, message) => {
//     setToast({
//       open: true,
//       type,
//       title,
//       message,
//     });
//   };

//   // Close toast function
//   const closeToast = () => {
//     setToast({ ...toast, open: false });
//   };

//   // Save entire WPR
//   const handleSaveWPR = async () => {
//     try {
//       setSaving(true);
      
//       // If no entries, show warning
//       if (!weekData.some(day => day.entries.length > 0)) {
//         showToast("warning", "Warning", "No entries to save");
//         return;
//       }
      
//       showToast("success", "Success", "Weekly Planning Report updated successfully!");
//       setTimeout(() => navigate(-1), 1500);
//     } catch (err) {
//       console.error("Error saving WPR:", err);
//       showToast("error", "Error", "Failed to save report");
//     } finally {
//       setSaving(false);
//     }
//   };

//   if (loading) {
//     return (
//       <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Box p={2}>
//         <Alert severity="error">{error}</Alert>
//         <Button onClick={() => navigate(-1)} sx={{ mt: 2 }}>
//           Go Back
//         </Button>
//       </Box>
//     );
//   }

//   if (!project) {
//     return (
//       <Box p={2}>
//         <Alert severity="warning">Project not found</Alert>
//         <Button onClick={() => navigate(-1)} sx={{ mt: 2 }}>
//           Go Back
//         </Button>
//       </Box>
//     );
//   }

//   return (
//     <LocalizationProvider dateAdapter={AdapterDateFns}>
//       <Box p={1}>
//         {/* ================= HEADER ================= */}
//         <Box mb={2}>
//           <Box display="flex" justifyContent="space-between" mb={1}>
//             <Typography sx={{ ...TYPOGRAPHY.H2, color: COLORS.SECONDARY }}>
//               Edit Weekly Planning Report (WPR)
//             </Typography>

//             <IconButton size="small" onClick={() => navigate(-1)}>
//               <Icon name="close3" color={COLORS.ERROR} />
//             </IconButton>
//           </Box>

//           <Box display="flex" flexDirection="column" gap={0.4}>
//             <Box display="flex" justifyContent="space-between" flexWrap={isMobile ? "wrap" : "nowrap"} gap={1}>
//               <Typography sx={TYPOGRAPHY.BODY_STANDARD}>
//                 Project Name:{" "}
//                 <span style={{ color: COLORS.SECONDARY }}>
//                   {project.projectName}
//                 </span>
//               </Typography>

//               <Box display="flex" alignItems="center" gap={1} flexWrap={isMobile ? "wrap" : "nowrap"}>
//                 <Typography sx={TYPOGRAPHY.BODY_STANDARD}>Week:</Typography>
                
//                 {weekStartDate && weekEndDate ? (
//                   <Box display="flex" alignItems="center" gap={1}>
//                     <TextField
//                       size="small"
//                       value={`${formatDateForWeekHeader(weekStartDate)} - ${formatDateForWeekHeader(weekEndDate)}`}
//                       onClick={() => setShowDatePicker(true)}
//                       sx={{
//                         width: isMobile ? "100%" : "200px",
//                         "& .MuiOutlinedInput-root": {
//                           borderRadius: "6px",
//                           height: "32px",
//                           pr: 0.5,
//                         },
//                       }}
//                       InputProps={{
//                         endAdornment: (
//                           <InputAdornment position="end">
//                             <IconButton size="small" onClick={() => setShowDatePicker(true)}>
//                               <Icon name="calendar" color={COLORS.SECONDARY} />
//                             </IconButton>
//                           </InputAdornment>
//                         ),
//                         readOnly: true,
//                       }}
//                     />
//                     <Button 
//                       size="small" 
//                       onClick={() => setShowDatePicker(true)}
//                       sx={{ textTransform: "none" }}
//                     >
//                       Change
//                     </Button>
//                   </Box>
//                 ) : (
//                   <Box
//                     sx={{
//                       display: "flex",
//                       alignItems: "center",
//                       border: `1px solid ${COLORS.LIGHT_SECONDARY}`,
//                       borderRadius: 1,
//                       px: 1.2,
//                       py: 0.3,
//                       gap: 0.6,
//                       fontSize: TYPOGRAPHY.BODY_SMALL.fontSize,
//                       color: COLORS.PRIMARY,
//                       minWidth: 110,
//                       justifyContent: "space-between",
//                       cursor: "pointer",
//                       "&:hover": {
//                         borderColor: COLORS.SECONDARY,
//                       }
//                     }}
//                     onClick={() => setShowDatePicker(true)}
//                   >
//                     {weekStartDate ? formatDateForWeekHeader(weekStartDate) : "DD/MM/YYYY - DD/MM/YYYY"}
//                     <Icon name="calendar3" color={COLORS.SECONDARY} />
//                   </Box>
//                 )}
//               </Box>
//             </Box>

//             <Box display="flex" justifyContent="space-between" flexWrap={isMobile ? "wrap" : "nowrap"} gap={1}>
//               <Typography sx={TYPOGRAPHY.BODY_STANDARD}>
//                 Address:{" "}
//                 <span style={{ color: COLORS.SECONDARY }}>
//                   {project.siteAddress || "Pune, Maharashtra"}
//                 </span>
//               </Typography>

//               <Typography sx={TYPOGRAPHY.BODY_STANDARD}>
//                 PMC:{" "}
//                 <span style={{ color: COLORS.SECONDARY }}>
//                   {companies.find(c => c._id === selectedCompany)?.name || "Arconest Consultants"}
//                 </span>
//               </Typography>
//             </Box>

//             <Box display="flex" justifyContent="space-between" flexWrap={isMobile ? "wrap" : "nowrap"} gap={1}>
//               <Typography sx={TYPOGRAPHY.BODY_STANDARD}>
//                 Developer:{" "}
//                 <span style={{ color: COLORS.SECONDARY }}>
//                   {project.developerName || "Vyankatesh Contracts"}
//                 </span>
//               </Typography>

//               <Typography sx={TYPOGRAPHY.BODY_STANDARD}>
//                 Engineer:{" "}
//                 <span style={{ color: COLORS.SECONDARY }}>
//                   {project.assignedEngineer?.name || project.assignedEngineerName || "Ashish Hase"}
//                 </span>
//               </Typography>
//             </Box>
//           </Box>

//           {/* HEADER BOTTOM LINE */}
//           <Box
//             mt={1.5}
//             height="1px"
//             sx={{ backgroundColor: COLORS.LIGHT_SECONDARY }}
//           />
//         </Box>

//         {/* Show warning if week not selected */}
//         {!weekStartDate && (
//           <Alert severity="warning" sx={{ mb: 2 }}>
//             Please select a week date to view/edit entries
//           </Alert>
//         )}

//         {/* ================= TABLE HEADER ================= */}
//         {weekStartDate && (
//           <>
//             <Box
//               display="flex"
//               alignItems="flex-start"
//               sx={{
//                 py: 1.2,
//                 ...TYPOGRAPHY.H4,
//                 color: COLORS.TEXT,
//                 borderBottom: `1px solid ${COLORS.LIGHT_SECONDARY}`,
//               }}
//             >
//               <FlexCell w={COLS.week} borderBottom="none">
//                 Week Days
//               </FlexCell>

//               <FlexCell flex={COLS.activity}>
//                 Targeted Activity <br /> Contractor/Vendor
//               </FlexCell>
//               <FlexCell flex={COLS.details}>Details</FlexCell>
//               <FlexCell flex={COLS.material}>
//                 Material/Machinery <br /> requirements
//               </FlexCell>
//               <FlexCell flex={COLS.support}>Support Needed</FlexCell>
//               <FlexCell flex={COLS.remark}>Remark</FlexCell>
//               <FlexCell w={COLS.action} />
//             </Box>

//             {/* ================= TABLE BODY ================= */}
//             {weekData.map((dayBlock, dayIndex) => (
//               <Box key={dayBlock.formattedDate}>
//                 {/* Render entries for this day */}
//                {dayBlock.entries.map((row, entryIndex) => (
//   <FlexRow key={entryIndex}>
//     {/* WEEK COLUMN */}
//     <FlexCell w={COLS.week} sx={{ height: "100%", display: "flex", alignItems: "center" }}>
//       {entryIndex === 0 && (
//         <Typography
//           sx={{
//             ...TYPOGRAPHY.BODY_LARGE,
//             color: COLORS.SECONDARY,
//             wordBreak: "break-word",
//             whiteSpace: "normal",
//           }}
//         >
//           {dayBlock.day.split(" ")[0]}
//           <br />
//           {formatDateForWeekColumn(dayBlock.date).split(" ").slice(1).join(" ")}
//         </Typography>
//       )}
//     </FlexCell>

//     {/* DATA COLUMNS */}
//     <FlexRowInner isLastEntry={entryIndex === dayBlock.entries.length - 1}>
//       <FlexCell flex={COLS.activity} sx={{ display: "flex", alignItems: "center" }}>
//         <Typography sx={{ 
//           color: COLORS.SECONDARY,
//           ...TYPOGRAPHY.BODY_LARGE,
//           wordBreak: "break-word",
//           whiteSpace: "normal",
//         }}>
//           {row.contractorVendor}
//         </Typography>
//       </FlexCell>
//       <FlexCell flex={COLS.details} sx={{ display: "flex", alignItems: "center" }}>
//         <Typography sx={{ 
//           color: COLORS.SECONDARY,
//           ...TYPOGRAPHY.BODY_LARGE,
//           wordBreak: "break-word",
//           whiteSpace: "normal",
//         }}>
//           {row.details}
//         </Typography>
//       </FlexCell>
//       <FlexCell flex={COLS.material} sx={{ display: "flex", alignItems: "center" }}>
//         <Typography sx={{ 
//           color: COLORS.SECONDARY,
//           ...TYPOGRAPHY.BODY_LARGE,
//           wordBreak: "break-word",
//           whiteSpace: "normal",
//         }}>
//           {row.materialMachineryRequirements}
//         </Typography>
//       </FlexCell>
//       <FlexCell flex={COLS.support} sx={{ display: "flex", alignItems: "center" }}>
//         <Typography sx={{ 
//           color: COLORS.SECONDARY,
//           ...TYPOGRAPHY.BODY_LARGE,
//           wordBreak: "break-word",
//           whiteSpace: "normal",
//         }}>
//           {row.supportNeeded}
//         </Typography>
//       </FlexCell>
//       <FlexCell flex={COLS.remark} sx={{ display: "flex", alignItems: "center" }}>
//         <Typography sx={{ 
//           color: COLORS.SECONDARY,
//           ...TYPOGRAPHY.BODY_LARGE,
//           wordBreak: "break-word",
//           whiteSpace: "normal",
//         }}>
//           {row.remarks}
//         </Typography>
//       </FlexCell>
//       <FlexCell w={COLS.action} sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5 }}>
//         <IconButton 
//           size="small"
//           onClick={() => handleEditEntry(dayIndex, entryIndex)}
//         >
//           <Icon name="Action3" color="#8ED081" />
//         </IconButton>
//         <IconButton 
//           size="small"
//           onClick={() => setDeleteDialog({
//             open: true,
//             entryId: row._id,
//             dayIndex: dayIndex,
//             entryIndex: entryIndex,
//           })}
//         >
//           <Icon name="close2" color={COLORS.ERROR} />
//         </IconButton>
//       </FlexCell>
//     </FlexRowInner>
//   </FlexRow>
// ))}

//                 {/* Show empty row if no entries and not in add/edit mode */}
//                 {/* {dayBlock.entries.length === 0 && activeDay !== dayBlock.formattedDate && (
//                   <FlexRow>
//                     <FlexCell w={COLS.week} sx={{ height: "100%", display: "flex", alignItems: "center" }}>
//                       <Typography
//                         sx={{
//                           ...TYPOGRAPHY.BODY_LARGE,
//                           color: COLORS.SECONDARY,
//                           wordBreak: "break-word",
//                           whiteSpace: "normal",
//                         }}
//                       >
//                         {dayBlock.day.split(" ")[0]}
//                         <br />
//                         {formatDateForWeekColumn(dayBlock.date).split(" ").slice(1).join(" ")}
//                       </Typography>
//                     </FlexCell>
//                     <FlexRowInner>
//                       <FlexCell flex={COLS.activity} sx={{ display: "flex", alignItems: "center" }} />
//                       <FlexCell flex={COLS.details} sx={{ display: "flex", alignItems: "center" }} />
//                       <FlexCell flex={COLS.material} sx={{ display: "flex", alignItems: "center" }} />
//                       <FlexCell flex={COLS.support} sx={{ display: "flex", alignItems: "center" }} />
//                       <FlexCell flex={COLS.remark} sx={{ display: "flex", alignItems: "center" }} />
//                       <FlexCell w={COLS.action} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }} />
//                     </FlexRowInner>
//                   </FlexRow>
//                 )} */}
//                 {dayBlock.entries.length === 0 && activeDay !== dayBlock.formattedDate && (
//   <FlexRow>
//     <FlexCell w={COLS.week} sx={{ height: "100%", display: "flex", alignItems: "center" }}>
//       <Typography
//         sx={{
//           ...TYPOGRAPHY.BODY_LARGE,
//           color: COLORS.SECONDARY,
//           wordBreak: "break-word",
//           whiteSpace: "normal",
//         }}
//       >
//         {dayBlock.day.split(" ")[0]}
//         <br />
//         {formatDateForWeekColumn(dayBlock.date).split(" ").slice(1).join(" ")}
//       </Typography>
//     </FlexCell>
//     <FlexRowInner isLastEntry={true}>
//       <FlexCell flex={COLS.activity} sx={{ display: "flex", alignItems: "center" }} />
//       <FlexCell flex={COLS.details} sx={{ display: "flex", alignItems: "center" }} />
//       <FlexCell flex={COLS.material} sx={{ display: "flex", alignItems: "center" }} />
//       <FlexCell flex={COLS.support} sx={{ display: "flex", alignItems: "center" }} />
//       <FlexCell flex={COLS.remark} sx={{ display: "flex", alignItems: "center" }} />
//       <FlexCell w={COLS.action} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }} />
//     </FlexRowInner>
//   </FlexRow>
// )}

//                 {/* ADD/EDIT ENTRY FORM */}
//                 {activeDay === dayBlock.formattedDate && (
//                   <Box mt={2}>
//                     <Typography sx={{ ...TYPOGRAPHY.H4, color: COLORS.SECONDARY, mb: 2 }}>
//                       {editingEntryId ? "Edit Entry for " : "Add New Entry for "}{dayBlock.formattedDate}
//                     </Typography>

//                     <Box display="flex" gap={2} mb={2}>
//                       <Field 
//                         label="Contractor / Vendor" 
//                         placeholder="Contractor / Vendor"
//                         value={newEntry.contractorVendor}
//                         onChange={(e) => setNewEntry({...newEntry, contractorVendor: e.target.value})}
//                       />
//                       <Field 
//                         label="Details" 
//                         placeholder="Details"
//                         value={newEntry.details}
//                         onChange={(e) => setNewEntry({...newEntry, details: e.target.value})}
//                       />
//                     </Box>

//                     <Box display="flex" gap={2} mb={2}>
//                       <Field 
//                         label="Material / Machinery Req" 
//                         placeholder="Material / Machinery Req"
//                         value={newEntry.materialMachineryRequirements}
//                         onChange={(e) => setNewEntry({...newEntry, materialMachineryRequirements: e.target.value})}
//                       />
//                       <Field 
//                         label="Support Needed" 
//                         placeholder="Support Needed"
//                         value={newEntry.supportNeeded}
//                         onChange={(e) => setNewEntry({...newEntry, supportNeeded: e.target.value})}
//                       />
//                     </Box>

//                     <Field
//                       label="Remark"
//                       placeholder="Remark Text Goes Here"
//                       multiline
//                       rows={3}
//                       value={newEntry.remarks}
//                       onChange={(e) => setNewEntry({...newEntry, remarks: e.target.value})}
//                       sx={{ mb: 2 }}
//                     />

//                     <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
//                       <Button
//                         onClick={handleCancel}
//                         startIcon={<Icon name="close2" />}
//                         sx={{
//                           textTransform: "none",
//                           color: COLORS.ERROR,
//                           fontWeight: 500,
//                         }}
//                         disabled={saving}
//                       >
//                         Cancel
//                       </Button>

//                       <Button
//                         startIcon={saving ? <CircularProgress size={16} color="inherit" /> : <Icon name={editingEntryId ? "check" : "plus2"} />}
//                         sx={{
//                           backgroundColor: COLORS.SECONDARY,
//                           color: "#fff",
//                           textTransform: "none",
//                           px: 2.5,
//                           "&:hover": {
//                             backgroundColor: COLORS.SECONDARY,
//                           },
//                           "&:disabled": {
//                             backgroundColor: COLORS.LIGHT_SECONDARY,
//                           }
//                         }}
//                         onClick={handleAddEntry}
//                         disabled={saving}
//                       >
//                         {saving ? (editingEntryId ? "Updating..." : "Adding...") : (editingEntryId ? "Update Entry" : "Add New Entry")}
//                       </Button>
//                     </Box>
//                   </Box>
//                 )}

//                 {/* ADD BUTTON (only show if not in add/edit mode) */}
//                 {/* {activeDay !== dayBlock.formattedDate && (
//                   <FlexEnd mt={1}>
//                     <Button
//                       size="small"
//                       startIcon={<Icon name="plus2" />}
//                       sx={{
//                         backgroundColor: COLORS.SECONDARY,
//                         color: "#fff",
//                         textTransform: "none",
//                       }}
//                       onClick={() => {
//                         setActiveDay(dayBlock.formattedDate);
//                         setEditingEntryId(null);
//                         setNewEntry({
//                           targetedActivity: "",
//                           contractorVendor: "",
//                           details: "",
//                           materialMachineryRequirements: "",
//                           supportNeeded: "",
//                           remarks: "",
//                         });
//                       }}
//                       disabled={!weekStartDate}
//                     >
//                       Add New Entry
//                     </Button>
//                   </FlexEnd>
//                 )} */}

//                 {/* SINGLE DAY SEPARATOR */}
//                 <Box
//                   mt={2}
//                   height="1px"
//                   sx={{ backgroundColor: COLORS.LIGHT_SECONDARY }}
//                 />
//               </Box>
//             ))}

//             {/* SAVE/UPDATE BUTTON */}
//             <Box display="flex" justifyContent="center" mt={3}>
//               <Button
//                 variant="contained"
//                 size="large"
//                 startIcon={<Icon name="save" />}
//                 sx={{
//                   backgroundColor: COLORS.PRIMARY,
//                   color: "#fff",
//                   textTransform: "none",
//                   px: 4,
//                   "&:hover": {
//                     backgroundColor: COLORS.SECONDARY,
//                   },
//                 }}
//                 onClick={handleSaveWPR}
//                 disabled={saving}
//               >
//                 {saving ? "Saving..." : "Update Weekly Report"}
//               </Button>
//             </Box>
//           </>
//         )}

//         {/* Date Picker Dialog */}
//         <Dialog open={showDatePicker} onClose={() => setShowDatePicker(false)}>
//           <DialogTitle>Select Week Start Date (Monday)</DialogTitle>
//           <DialogContent>
//             <DatePicker
//               value={weekStartDate}
//               onChange={handleWeekDateSelect}
//               openTo="day"
//               views={['year', 'month', 'day']}
//               renderInput={(params) => (
//                 <TextField 
//                   {...params} 
//                   fullWidth 
//                   sx={{ mt: 2, display: 'none' }} 
//                   InputProps={{
//                     ...params.InputProps,
//                     readOnly: true,
//                   }}
//                 />
//               )}
//               shouldDisableDate={(date) => {
//                 // Only allow Mondays to be selected
//                 return date.getDay() !== 1;
//               }}
//             />
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setShowDatePicker(false)}>Cancel</Button>
//           </DialogActions>
//         </Dialog>

//         {/* DELETE CONFIRMATION DIALOG */}
//         <Dialog
//           open={deleteDialog.open}
//           onClose={() => setDeleteDialog({ open: false, entryId: null, dayIndex: null, entryIndex: null })}
//         >
//           <DialogTitle>Confirm Delete</DialogTitle>
//           <DialogContent>
//             <Typography>Are you sure you want to delete this entry?</Typography>
//           </DialogContent>
//           <DialogActions>
//             <Button 
//               onClick={() => setDeleteDialog({ open: false, entryId: null, dayIndex: null, entryIndex: null })}
//               disabled={saving}
//             >
//               Cancel
//             </Button>
//             <Button 
//               onClick={handleDeleteEntry}
//               color="error"
//               disabled={saving}
//             >
//               {saving ? "Deleting..." : "Delete"}
//             </Button>
//           </DialogActions>
//         </Dialog>

//         {/* Toast Component */}
//         <AppToast
//           open={toast.open}
//           type={toast.type}
//           title={toast.title}
//           message={toast.message}
//           onClose={closeToast}
//         />
//       </Box>
//     </LocalizationProvider>
//   );
// }

// /* ================= REUSABLE COMPONENTS ================= */

// const FlexRow = ({ children, header }) => (
//   <Box
//     display="flex"
//     alignItems="stretch"
//     sx={{
//       py: header ? 1.2 : 1,
//       fontWeight: header ? 600 : 400,
//     }}
//   >
//     {children}
//   </Box>
// );

// const FlexCell = ({ children, flex, w, sx = {}, borderBottom = "none", ...props }) => (
//   <Box 
//     flex={flex} 
//     width={w} 
//     px={1} 
//     sx={{ 
//       ...TYPOGRAPHY.BODY_LARGE,
//       borderBottom: borderBottom,
//       ...sx
//     }}
//     {...props}
//   >
//     {children}
//   </Box>
// );

// // const FlexRowInner = ({ children, header }) => (
// //   <Box
// //     display="flex"
// //     flex={1}
// //     alignItems="stretch"
// //     sx={{
// //       borderBottom: `1px solid ${COLORS.LIGHT_SECONDARY}`,
// //     }}
// //   >
// //     {children}
// //   </Box>
// // );
// const FlexRowInner = ({ children, header, isLastEntry = false }) => (
//   <Box
//     display="flex"
//     flex={1}
//     alignItems="stretch"
//     sx={{
//       borderBottom: isLastEntry ? 'none' : `1px solid ${COLORS.LIGHT_SECONDARY}`,
//     }}
//   >
//     {children}
//   </Box>
// );
// const FlexEnd = ({ children, mt }) => (
//   <Box display="flex" justifyContent="flex-end" mt={mt}>
//     {children}
//   </Box>
// );

// const Field = ({ label, sx = {}, ...props }) => (
//   <Box display="flex" flexDirection="column" flex={1}>
//     <Typography
//       sx={{
//         fontSize: "12px",
//         fontWeight: 500,
//         color: COLORS.SECONDARY,
//         mb: 0.5,
//       }}
//     >
//       {label}
//     </Typography>

//     <TextField
//       fullWidth
//       variant="outlined"
//       {...props}
//       sx={{
//         "& .MuiOutlinedInput-root": {
//           height: props.multiline ? "auto" : "40px",
//           borderRadius: "6px",
//           fontSize: "13px",
//         },
//         "& .MuiOutlinedInput-notchedOutline": {
//           borderColor: COLORS.LIGHT_SECONDARY,
//         },
//         "&:hover .MuiOutlinedInput-notchedOutline": {
//           borderColor: COLORS.SECONDARY,
//         },
//         "& .MuiInputBase-input::placeholder": {
//           color: COLORS.LIGHT_SECONDARY,
//           opacity: 1,
//           fontSize: "13px",
//         },
//         ...sx,
//       }}
//     />
//   </Box>
// );
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  TextField,
  IconButton,
  InputAdornment,
  CircularProgress,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  useMediaQuery,
} from "@mui/material";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Icon } from "../../icons";
import { COLORS, TYPOGRAPHY } from "../../constants/color";
import axios from "axios";
import { useAuth } from "../../context/authContext";
import { url } from "../../constants/url";
import AppToast from "../../components/AppToast";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format } from "date-fns";
import useFormPersistence from "../../hooks/useFormPersistence";

export default function EditWPR() {
  const { projectId } = useParams();
  const { token, userData } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width: 768px)");

  // Get week data from navigation state
  const { 
    weekType, 
    weekStartDate: initialWeekStartDate, 
    weekEndDate: initialWeekEndDate,
    projectName: propProjectName 
  } = location.state || {};

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [project, setProject] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  
  // Week date state - Initialize from props
  const [weekStartDate, setWeekStartDate] = useState(
    initialWeekStartDate ? new Date(initialWeekStartDate) : null
  );
  const [weekEndDate, setWeekEndDate] = useState(
    initialWeekEndDate ? new Date(initialWeekEndDate) : null
  );
  const [showDatePicker, setShowDatePicker] = useState(false);
  
  // Toast state
  const [toast, setToast] = useState({
    open: false,
    type: "success",
    title: "",
    message: "",
  });
  
  // Week data state
  const [weekData, setWeekData] = useState([]);
  const [wprId, setWprId] = useState(null);
  
  const [activeDay, setActiveDay] = useState(null);
  const [editingEntryId, setEditingEntryId] = useState(null);

  // Add/Edit entry form state
  const newEntryPersistenceKey = `wpr-edit-entry-${projectId}-${activeDay || 'no-day'}-${editingEntryId || 'new'}`;
  const [newEntry, setNewEntry, clearNewEntryPersistence] = useFormPersistence(newEntryPersistenceKey, {
    targetedActivity: "",
    contractorVendor: "",
    details: "",
    materialMachineryRequirements: "",
    supportNeeded: "",
    remarks: "",
  });
  const [saving, setSaving] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    entryId: null,
    dayIndex: null,
    entryIndex: null,
  });

  const COLS = {
    week: "160px",
    activity: 1,
    details: 1.4,
    material: 1.3,
    support: 1.1,
    remark: 1.2,
    action: "40px",
  };

  // Format date function
  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const day = d.getDate();
    const suffix = getDaySuffix(day);
    const month = d.toLocaleString('default', { month: 'short' });
    const year = d.getFullYear().toString().slice(-2);
    const dayName = d.toLocaleString('default', { weekday: 'long' });
    
    return `${dayName} ${day}${suffix} ${month} '${year}`;
  };

  // Format date for week column (Monday 5th Jan '26)
  const formatDateForWeekColumn = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const day = d.getDate();
    const suffix = getDaySuffix(day);
    const month = d.toLocaleString('default', { month: 'short' });
    const year = d.getFullYear().toString().slice(-2);
    const dayName = d.toLocaleString('default', { weekday: 'long' });
    
    return `${dayName} ${day}${suffix} ${month} '${year}`;
  };

  // Format date for week header (DD/MM/YY - DD/MM/YY)
  const formatDateForWeekHeader = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return format(d, "dd/MM/yy");
  };

  const getDaySuffix = (day) => {
    if (day >= 11 && day <= 13) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  };

  // Fetch project data and WPR data
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const config = {
          headers: {
            Authorization: token ? `Bearer ${token}` : undefined,
          },
        };
        
        // Fetch project details
        const projectResponse = await axios.get(
          `${url}/api/inhouse-projects/fetch-by/${projectId}`,
          config
        );
        
        if (projectResponse.data.project) {
          setProject(projectResponse.data.project);
          
          // Fetch companies for PMC dropdown
          const companiesResponse = await axios.get(
            `${url}/api/company/fetch`,
            config
          );
          
          if (companiesResponse.data.data) {
            setCompanies(companiesResponse.data.data);
            // Select first company by default
            if (companiesResponse.data.data.length > 0) {
              setSelectedCompany(companiesResponse.data.data[0]._id);
            }
          }
          
          // If week dates are provided, fetch WPR data
          if (weekStartDate && weekEndDate) {
            await fetchWPRData();
          } else {
            setLoading(false);
          }
        } else {
          setError("Project not found");
          setLoading(false);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Failed to load project data. Please try again.");
        setLoading(false);
      }
    };
    
    if (projectId && token) {
      fetchData();
    }
  }, [projectId, token, weekStartDate, weekEndDate]);

  // Fetch WPR data for the selected week
  const fetchWPRData = async () => {
    try {
      const config = {
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
        },
      };
      
      // Fetch all WPRs for this project
      const wprResponse = await axios.get(
        `${url}/api/wpr/fetch-by-project/${projectId}`,
        config
      );
      
      if (wprResponse.data.wprs && wprResponse.data.wprs.length > 0) {
        // Find WPR for the selected week
        const weekStartStr = format(weekStartDate, "yyyy-MM-dd");
        const weekEndStr = format(weekEndDate, "yyyy-MM-dd");
        
        const existingWPR = wprResponse.data.wprs.find(wpr => {
          if (!wpr.weekStartDate || !wpr.weekEndDate) return false;
          
          const wprStart = format(new Date(wpr.weekStartDate), "yyyy-MM-dd");
          const wprEnd = format(new Date(wpr.weekEndDate), "yyyy-MM-dd");
          
          return wprStart === weekStartStr && wprEnd === weekEndStr;
        });
        
        if (existingWPR) {
          setWprId(existingWPR._id);
          // Generate week data with existing entries
          generateWeekDataWithEntries(existingWPR.dailyEntries || []);
        } else {
          // No existing WPR for this week, generate empty week data
          generateWeekData();
        }
      } else {
        // No WPRs exist for this project, generate empty week data
        generateWeekData();
      }
    } catch (err) {
      console.error("Error fetching WPR data:", err);
      // Generate empty week data on error
      generateWeekData();
    } finally {
      setLoading(false);
    }
  };

  // Generate week data with existing entries
  const generateWeekDataWithEntries = (dailyEntries) => {
    const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const weekDataArray = [];
    
    const currentDate = new Date(weekStartDate);
    
    for (let i = 0; i < 6; i++) {
      const date = new Date(currentDate);
      date.setDate(currentDate.getDate() + i);
      
      // Format date for comparison (YYYY-MM-DD)
      const dateStr = format(date, "yyyy-MM-dd");
      
      // Find entries for this specific date
      const dayEntry = dailyEntries.find(entry => {
        if (!entry.date) return false;
        
        const entryDate = new Date(entry.date);
        const entryDateStr = format(entryDate, "yyyy-MM-dd");
        
        // Match by both day name AND date string
        return entry.day === days[i] && entryDateStr === dateStr;
      });
      
      weekDataArray.push({
        day: days[i],
        date: date,
        formattedDate: formatDate(date),
        entries: dayEntry?.entries?.map(entry => ({
          _id: entry._id,
          targetedActivity: entry.targetedActivity || "",
          contractorVendor: entry.contractorVendor || "",
          details: entry.details || "",
          materialMachineryRequirements: entry.materialMachineryRequirements || "",
          supportNeeded: entry.supportNeeded || "",
          remarks: entry.remarks || "",
        })) || [],
      });
    }
    
    setWeekData(weekDataArray);
  };

  // Generate empty week data structure
  const generateWeekData = () => {
    const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const weekDataArray = [];
    
    const currentDate = new Date(weekStartDate);
    
    for (let i = 0; i < 6; i++) {
      const date = new Date(currentDate);
      date.setDate(currentDate.getDate() + i);
      
      weekDataArray.push({
        day: days[i],
        date: date,
        formattedDate: formatDate(date),
        entries: [],
      });
    }
    
    setWeekData(weekDataArray);
  };

  // Handle week date selection (force Monday selection)
  const handleWeekDateSelect = (date) => {
    if (!date) return;
    
    // Ensure selected date is a Monday
    const selectedDate = new Date(date);
    const dayOfWeek = selectedDate.getDay();
    const monday = new Date(selectedDate);
    
    // Adjust to Monday (day 1 in JS Date is Sunday = 0, Monday = 1)
    if (dayOfWeek === 0) {
      monday.setDate(selectedDate.getDate() - 6); // Sunday goes to previous Monday
    } else if (dayOfWeek > 1) {
      monday.setDate(selectedDate.getDate() - (dayOfWeek - 1));
    }
    
    // Calculate Saturday (6 days after Monday)
    const saturday = new Date(monday);
    saturday.setDate(monday.getDate() + 5);
    
    setWeekStartDate(monday);
    setWeekEndDate(saturday);
    setShowDatePicker(false);
    
    showToast("success", "Week Selected", `Week: ${formatDateForWeekHeader(monday)} - ${formatDateForWeekHeader(saturday)}`);
  };

  // Handle adding new entry
  const handleAddEntry = async () => {
    if (!activeDay) return;
    
    try {
      setSaving(true);
      
      const config = {
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
          "Content-Type": "application/json",
        },
      };
      
      // Find the day index
      const dayIndex = weekData.findIndex(day => day.formattedDate === activeDay);
      if (dayIndex === -1) {
        showToast("error", "Error", "Day not found");
        return;
      }
      
      // If editing existing entry
      if (editingEntryId && wprId) {
        await updateExistingEntry(dayIndex);
      } else {
        // Add new entry
        await addNewEntry(dayIndex);
      }
    } catch (err) {
      console.error("Error saving entry:", err);
      showToast("error", "Error", err.response?.data?.message || "Failed to save entry");
    } finally {
      setSaving(false);
    }
  };

  // Add new entry
  const addNewEntry = async (dayIndex) => {
    const config = {
      headers: {
        Authorization: token ? `Bearer ${token}` : undefined,
        "Content-Type": "application/json",
      },
    };
    
    const weekStartStr = weekStartDate.toISOString().split('T')[0];
    const weekEndStr = weekEndDate.toISOString().split('T')[0];
    
    // Get or create WPR
    let currentWprId = wprId;
    
    if (!currentWprId) {
      // Create new WPR
      const wprData = {
        projectId,
        title: `WPR - ${formatDateForWeekHeader(weekStartDate)} to ${formatDateForWeekHeader(weekEndDate)}`,
        weekStartDate: weekStartStr,
        weekEndDate: weekEndStr,
        dailyEntries: [],
      };
      
      const wprResponse = await axios.post(
        `${url}/api/wpr/add`,
        wprData,
        config
      );
      
      if (wprResponse.data.data?._id) {
        currentWprId = wprResponse.data.data._id;
        setWprId(currentWprId);
      }
    }
    
    if (currentWprId) {
      const selectedDay = weekData[dayIndex];
      
      const dailyEntryData = {
        day: selectedDay.day,
        date: selectedDay.date.toISOString().split('T')[0],
        entries: [{
          targetedActivity: newEntry.targetedActivity,
          contractorVendor: newEntry.contractorVendor,
          details: newEntry.details,
          materialMachineryRequirements: newEntry.materialMachineryRequirements,
          supportNeeded: newEntry.supportNeeded,
          remarks: newEntry.remarks || "",
        }]
      };
      
      const entryResponse = await axios.patch(
        `${url}/api/wpr/add/${currentWprId}/daily-entry`,
        dailyEntryData,
        config
      );
      
      if (entryResponse.data.wpr) {
        // Update local state with the new entry ID from backend
        const updatedWeekData = [...weekData];
        const newEntryFromBackend = entryResponse.data.wpr.dailyEntries
          ?.find(de => de.day === selectedDay.day && new Date(de.date).toDateString() === selectedDay.date.toDateString())
          ?.entries?.slice(-1)[0]; // Get the last added entry
        
        if (updatedWeekData[dayIndex].entries) {
          updatedWeekData[dayIndex].entries.push({
            ...newEntry,
            _id: newEntryFromBackend?._id || Date.now().toString()
          });
        } else {
          updatedWeekData[dayIndex].entries = [{
            ...newEntry,
            _id: newEntryFromBackend?._id || Date.now().toString()
          }];
        }
        setWeekData(updatedWeekData);
        
        // Reset form
        resetForm();
        
        showToast("success", "Success", "Entry added successfully!");
      }
    }
  };

  // Update existing entry
  const updateExistingEntry = async (dayIndex) => {
    const config = {
      headers: {
        Authorization: token ? `Bearer ${token}` : undefined,
        "Content-Type": "application/json",
      },
    };
    
    const updateData = {
      targetedActivity: newEntry.targetedActivity,
      contractorVendor: newEntry.contractorVendor,
      details: newEntry.details,
      materialMachineryRequirements: newEntry.materialMachineryRequirements,
      supportNeeded: newEntry.supportNeeded,
      remarks: newEntry.remarks || "",
    };
    
    const updateResponse = await axios.put(
      `${url}/api/wpr/update/${wprId}/entry/${editingEntryId}`,
      updateData,
      config
    );
    
    if (updateResponse.data.wpr) {
      // Update local state
      const updatedWeekData = [...weekData];
      const entryIndex = updatedWeekData[dayIndex].entries.findIndex(entry => entry._id === editingEntryId);
      
      if (entryIndex !== -1) {
        updatedWeekData[dayIndex].entries[entryIndex] = {
          ...updatedWeekData[dayIndex].entries[entryIndex],
          ...newEntry
        };
        setWeekData(updatedWeekData);
      }
      
      // Reset form
      resetForm();
      
      showToast("success", "Success", "Entry updated successfully!");
    }
  };

  // Handle deleting entry
  const handleDeleteEntry = async () => {
    const { dayIndex, entryIndex, entryId } = deleteDialog;
    
    try {
      setSaving(true);
      
      const config = {
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
        },
      };
      
      // Delete from backend if we have wprId and entryId
      if (wprId && entryId && !entryId.startsWith('temp-')) {
        await axios.delete(
          `${url}/api/wpr/delete/${wprId}/entry/${entryId}`,
          config
        );
      }
      
      // Remove from local state
      const updatedWeekData = [...weekData];
      updatedWeekData[dayIndex].entries.splice(entryIndex, 1);
      setWeekData(updatedWeekData);
      
      setDeleteDialog({ open: false, entryId: null, dayIndex: null, entryIndex: null });
      showToast("success", "Success", "Entry deleted successfully!");
    } catch (err) {
      console.error("Error deleting entry:", err);
      showToast("error", "Error", "Failed to delete entry");
    } finally {
      setSaving(false);
    }
  };

  // Handle edit entry click
  const handleEditEntry = (dayIndex, entryIndex) => {
    const entry = weekData[dayIndex].entries[entryIndex];
    setActiveDay(weekData[dayIndex].formattedDate);
    setEditingEntryId(entry._id);
    setNewEntry({
      targetedActivity: entry.targetedActivity || "",
      contractorVendor: entry.contractorVendor || "",
      details: entry.details || "",
      materialMachineryRequirements: entry.materialMachineryRequirements || "",
      supportNeeded: entry.supportNeeded || "",
      remarks: entry.remarks || "",
    });
  };

  // Reset form
  const resetForm = () => {
    if (clearNewEntryPersistence) clearNewEntryPersistence();
    setActiveDay(null);
    setEditingEntryId(null);
    setNewEntry({
      targetedActivity: "",
      contractorVendor: "",
      details: "",
      materialMachineryRequirements: "",
      supportNeeded: "",
      remarks: "",
    });
  };

  // Cancel edit/add
  const handleCancel = () => {
    resetForm();
  };

  // Show toast function
  const showToast = (type, title, message) => {
    setToast({
      open: true,
      type,
      title,
      message,
    });
  };

  // Close toast function
  const closeToast = () => {
    setToast({ ...toast, open: false });
  };

  // Save entire WPR
  const handleSaveWPR = async () => {
    try {
      setSaving(true);
      
      // If no entries, show warning
      if (!weekData.some(day => day.entries.length > 0)) {
        showToast("warning", "Warning", "No entries to save");
        return;
      }
      
      showToast("success", "Success", "Weekly Planning Report updated successfully!");
      setTimeout(() => navigate(-1), 1500);
    } catch (err) {
      console.error("Error saving WPR:", err);
      showToast("error", "Error", "Failed to save report");
    } finally {
      setSaving(false);
    }
  };

  // Handle download WPR report
  const handleDownloadReport = async () => {
    try {
      if (!wprId) {
        showToast("error", "Error", "No WPR data available to download");
        return;
      }
      
      setDownloading(true);
      
      const config = {
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
        },
        responseType: 'blob'
      };
      
      const response = await axios.get(
        `${url}/api/wpr/download/${wprId}/report`,
        config
      );
      
      // Create blob and download
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const urlBlob = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = urlBlob;
      
      // Generate filename
      const date = new Date(weekStartDate);
      const dateStr = date.toLocaleDateString('en-GB').replace(/\//g, '-');
      const projectName = project?.projectName?.replace(/[^a-zA-Z0-9]/g, '_') || 'WPR';
      link.download = `WPR_${projectName}_${dateStr}.pdf`;
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(urlBlob);
      
      showToast("success", "Success", "WPR report downloaded successfully!");
      
    } catch (err) {
      console.error("Error downloading report:", err);
      showToast("error", "Error", "Failed to download report. Please try again.");
    } finally {
      setDownloading(false);
    }
  };

  // Auto-select week if passed from props
  useEffect(() => {
    if (initialWeekStartDate && initialWeekEndDate) {
      setWeekStartDate(new Date(initialWeekStartDate));
      setWeekEndDate(new Date(initialWeekEndDate));
    }
  }, [initialWeekStartDate, initialWeekEndDate]);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={2}>
        <Alert severity="error">{error}</Alert>
        <Button onClick={() => navigate(-1)} sx={{ mt: 2 }}>
          Go Back
        </Button>
      </Box>
    );
  }

  if (!project) {
    return (
      <Box p={2}>
        <Alert severity="warning">Project not found</Alert>
        <Button onClick={() => navigate(-1)} sx={{ mt: 2 }}>
          Go Back
        </Button>
      </Box>
    );
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box p={1}>
        {/* ================= HEADER ================= */}
        <Box mb={2}>
          <Box display="flex" justifyContent="space-between" mb={1}>
            {/* LEFT: TITLE + DOWNLOAD BUTTON */}
            <Box display="flex" alignItems="center" gap={1.5}>
              <Typography sx={{ ...TYPOGRAPHY.H2, color: COLORS.SECONDARY }}>
                {wprId ? "Weekly Planning Report (WPR)" : "Weekly Planning Report (WPR)"}
              </Typography>

              {/* DOWNLOAD BUTTON - Similar to DPR */}
              {wprId && (
                <Button
                  onClick={handleDownloadReport}
                  disabled={downloading}
                  startIcon={
                    downloading ? (
                      <CircularProgress size={16} color="inherit" />
                    ) : (
                      <Icon name="download1" />
                    )
                  }
                  sx={{
                    backgroundColor: COLORS.SECONDARY,
                    color: "#fff",
                    textTransform: "none",
                    borderRadius: "7px",
                    px: 2,
                    height: 36,
                    "&:hover": {
                      backgroundColor: COLORS.PRIMARY,
                    },
                  }}
                >
                  {downloading ? "Downloading..." : "Download"}
                </Button>
              )}
            </Box>

            {/* RIGHT: CLOSE BUTTON */}
            <IconButton size="small" onClick={() => navigate(-1)}>
              <Icon name="close3" color={COLORS.ERROR} />
            </IconButton>
          </Box>

          <Box display="flex" flexDirection="column" gap={0.4}>
            <Box display="flex" justifyContent="space-between" flexWrap={isMobile ? "wrap" : "nowrap"} gap={1}>
              <Typography sx={TYPOGRAPHY.BODY_STANDARD}>
                Project Name:{" "}
                <span style={{ color: COLORS.SECONDARY }}>
                  {propProjectName || project.projectName}
                </span>
              </Typography>

              <Box display="flex" alignItems="center" gap={1} flexWrap={isMobile ? "wrap" : "nowrap"}>
                <Typography sx={TYPOGRAPHY.BODY_STANDARD}>Week:</Typography>
                
                {weekStartDate && weekEndDate ? (
                  <Box display="flex" alignItems="center" gap={1}>
                    <TextField
                      size="small"
                      value={`${formatDateForWeekHeader(weekStartDate)} - ${formatDateForWeekHeader(weekEndDate)}`}
                      onClick={() => setShowDatePicker(true)}
                      sx={{
                        width: isMobile ? "100%" : "200px",
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "6px",
                          height: "32px",
                          pr: 0.5,
                        },
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton size="small" onClick={() => setShowDatePicker(true)}>
                              <Icon name="calendar" color={COLORS.SECONDARY} />
                            </IconButton>
                          </InputAdornment>
                        ),
                        readOnly: true,
                      }}
                    />
                    <Button 
                      size="small" 
                      onClick={() => setShowDatePicker(true)}
                      sx={{ textTransform: "none" }}
                    >
                      Change
                    </Button>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      border: `1px solid ${COLORS.LIGHT_SECONDARY}`,
                      borderRadius: 1,
                      px: 1.2,
                      py: 0.3,
                      gap: 0.6,
                      fontSize: TYPOGRAPHY.BODY_SMALL.fontSize,
                      color: COLORS.PRIMARY,
                      minWidth: 110,
                      justifyContent: "space-between",
                      cursor: "pointer",
                      "&:hover": {
                        borderColor: COLORS.SECONDARY,
                      }
                    }}
                    onClick={() => setShowDatePicker(true)}
                  >
                    {weekStartDate ? formatDateForWeekHeader(weekStartDate) : "DD/MM/YYYY - DD/MM/YYYY"}
                    <Icon name="calendar3" color={COLORS.SECONDARY} />
                  </Box>
                )}
              </Box>
            </Box>

            <Box display="flex" justifyContent="space-between" flexWrap={isMobile ? "wrap" : "nowrap"} gap={1}>
              <Typography sx={TYPOGRAPHY.BODY_STANDARD}>
                Address:{" "}
                <span style={{ color: COLORS.SECONDARY }}>
                  {project.siteAddress || "Pune, Maharashtra"}
                </span>
              </Typography>

              <Typography sx={TYPOGRAPHY.BODY_STANDARD}>
                PMC:{" "}
                <span style={{ color: COLORS.SECONDARY }}>
                  {companies.find(c => c._id === selectedCompany)?.name || "Arconest Consultants"}
                </span>
              </Typography>
            </Box>

            <Box display="flex" justifyContent="space-between" flexWrap={isMobile ? "wrap" : "nowrap"} gap={1}>
              <Typography sx={TYPOGRAPHY.BODY_STANDARD}>
                Developer:{" "}
                <span style={{ color: COLORS.SECONDARY }}>
                  {project.developerName || "Vyankatesh Contracts"}
                </span>
              </Typography>

              <Typography sx={TYPOGRAPHY.BODY_STANDARD}>
                Engineer:{" "}
                <span style={{ color: COLORS.SECONDARY }}>
                  {project.assignedEngineer?.name || project.assignedEngineerName || "Ashish Hase"}
                </span>
              </Typography>
            </Box>
          </Box>

          {/* HEADER BOTTOM LINE */}
          <Box
            mt={1.5}
            height="1px"
            sx={{ backgroundColor: COLORS.LIGHT_SECONDARY }}
          />
        </Box>

        {/* Show warning if week not selected */}
        {!weekStartDate && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            Please select a week date to view/edit entries
          </Alert>
        )}

        {/* ================= TABLE HEADER ================= */}
        {weekStartDate && (
          <>
            <Box
              display="flex"
              alignItems="flex-start"
              sx={{
                py: 1.2,
                ...TYPOGRAPHY.H4,
                color: COLORS.TEXT,
                borderBottom: `1px solid ${COLORS.LIGHT_SECONDARY}`,
              }}
            >
              <FlexCell w={COLS.week} borderBottom="none">
                Week Days
              </FlexCell>

              <FlexCell flex={COLS.activity}>
                Targeted Activity <br /> Contractor/Vendor
              </FlexCell>
              <FlexCell flex={COLS.details}>Details</FlexCell>
              <FlexCell flex={COLS.material}>
                Material/Machinery <br /> requirements
              </FlexCell>
              <FlexCell flex={COLS.support}>Support Needed</FlexCell>
              <FlexCell flex={COLS.remark}>Remark</FlexCell>
              <FlexCell w={COLS.action} />
            </Box>

            {/* ================= TABLE BODY ================= */}
            {weekData.map((dayBlock, dayIndex) => (
              <Box key={dayBlock.formattedDate}>
                {/* Render entries for this day */}
                {dayBlock.entries.map((row, entryIndex) => (
                  <FlexRow key={entryIndex}>
                    {/* WEEK COLUMN */}
                    <FlexCell w={COLS.week} sx={{ height: "100%", display: "flex", alignItems: "center" }}>
                      {entryIndex === 0 && (
                        <Typography
                          sx={{
                            ...TYPOGRAPHY.BODY_LARGE,
                            color: COLORS.SECONDARY,
                            wordBreak: "break-word",
                            whiteSpace: "normal",
                          }}
                        >
                          {dayBlock.day.split(" ")[0]}
                          <br />
                          {formatDateForWeekColumn(dayBlock.date).split(" ").slice(1).join(" ")}
                        </Typography>
                      )}
                    </FlexCell>

                    {/* DATA COLUMNS */}
                    <FlexRowInner isLastEntry={entryIndex === dayBlock.entries.length - 1}>
                      <FlexCell flex={COLS.activity} sx={{ display: "flex", alignItems: "center" }}>
                        <Typography sx={{ 
                          color: COLORS.SECONDARY,
                          ...TYPOGRAPHY.BODY_LARGE,
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}>
                          {row.contractorVendor}
                        </Typography>
                      </FlexCell>
                      <FlexCell flex={COLS.details} sx={{ display: "flex", alignItems: "center" }}>
                        <Typography sx={{ 
                          color: COLORS.SECONDARY,
                          ...TYPOGRAPHY.BODY_LARGE,
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}>
                          {row.details}
                        </Typography>
                      </FlexCell>
                      <FlexCell flex={COLS.material} sx={{ display: "flex", alignItems: "center" }}>
                        <Typography sx={{ 
                          color: COLORS.SECONDARY,
                          ...TYPOGRAPHY.BODY_LARGE,
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}>
                          {row.materialMachineryRequirements}
                        </Typography>
                      </FlexCell>
                      <FlexCell flex={COLS.support} sx={{ display: "flex", alignItems: "center" }}>
                        <Typography sx={{ 
                          color: COLORS.SECONDARY,
                          ...TYPOGRAPHY.BODY_LARGE,
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}>
                          {row.supportNeeded}
                        </Typography>
                      </FlexCell>
                      <FlexCell flex={COLS.remark} sx={{ display: "flex", alignItems: "center" }}>
                        <Typography sx={{ 
                          color: COLORS.SECONDARY,
                          ...TYPOGRAPHY.BODY_LARGE,
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}>
                          {row.remarks}
                        </Typography>
                      </FlexCell>
                      <FlexCell w={COLS.action} sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5 }}>
                        <IconButton 
                          size="small"
                          onClick={() => handleEditEntry(dayIndex, entryIndex)}
                        >
                          <Icon name="Action3" color="#8ED081" />
                        </IconButton>
                        <IconButton 
                          size="small"
                          onClick={() => setDeleteDialog({
                            open: true,
                            entryId: row._id,
                            dayIndex: dayIndex,
                            entryIndex: entryIndex,
                          })}
                        >
                          <Icon name="close2" color={COLORS.ERROR} />
                        </IconButton>
                      </FlexCell>
                    </FlexRowInner>
                  </FlexRow>
                ))}

                {/* Show empty row if no entries and not in add/edit mode */}
                {dayBlock.entries.length === 0 && activeDay !== dayBlock.formattedDate && (
                  <FlexRow>
                    <FlexCell w={COLS.week} sx={{ height: "100%", display: "flex", alignItems: "center" }}>
                      <Typography
                        sx={{
                          ...TYPOGRAPHY.BODY_LARGE,
                          color: COLORS.SECONDARY,
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                        {dayBlock.day.split(" ")[0]}
                        <br />
                        {formatDateForWeekColumn(dayBlock.date).split(" ").slice(1).join(" ")}
                      </Typography>
                    </FlexCell>
                    <FlexRowInner isLastEntry={true}>
                      <FlexCell flex={COLS.activity} sx={{ display: "flex", alignItems: "center" }} />
                      <FlexCell flex={COLS.details} sx={{ display: "flex", alignItems: "center" }} />
                      <FlexCell flex={COLS.material} sx={{ display: "flex", alignItems: "center" }} />
                      <FlexCell flex={COLS.support} sx={{ display: "flex", alignItems: "center" }} />
                      <FlexCell flex={COLS.remark} sx={{ display: "flex", alignItems: "center" }} />
                      <FlexCell w={COLS.action} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }} />
                    </FlexRowInner>
                  </FlexRow>
                )}

                {/* ADD/EDIT ENTRY FORM */}
                {activeDay === dayBlock.formattedDate && (
                  <Box mt={2}>
                    <Typography sx={{ ...TYPOGRAPHY.H4, color: COLORS.SECONDARY, mb: 2 }}>
                      {editingEntryId ? "Edit Entry for " : "Add New Entry for "}{dayBlock.formattedDate}
                    </Typography>

                    <Box display="flex" gap={2} mb={2}>
                      <Field 
                        label="Contractor / Vendor" 
                        placeholder="Contractor / Vendor"
                        value={newEntry.contractorVendor}
                        onChange={(e) => setNewEntry({...newEntry, contractorVendor: e.target.value})}
                      />
                      <Field 
                        label="Details" 
                        placeholder="Details"
                        value={newEntry.details}
                        onChange={(e) => setNewEntry({...newEntry, details: e.target.value})}
                      />
                    </Box>

                    <Box display="flex" gap={2} mb={2}>
                      <Field 
                        label="Material / Machinery Req" 
                        placeholder="Material / Machinery Req"
                        value={newEntry.materialMachineryRequirements}
                        onChange={(e) => setNewEntry({...newEntry, materialMachineryRequirements: e.target.value})}
                      />
                      <Field 
                        label="Support Needed" 
                        placeholder="Support Needed"
                        value={newEntry.supportNeeded}
                        onChange={(e) => setNewEntry({...newEntry, supportNeeded: e.target.value})}
                      />
                    </Box>

                    <Field
                      label="Remark"
                      placeholder="Remark Text Goes Here"
                      multiline
                      rows={3}
                      value={newEntry.remarks}
                      onChange={(e) => setNewEntry({...newEntry, remarks: e.target.value})}
                      sx={{ mb: 2 }}
                    />

                    <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                      <Button
                        onClick={handleCancel}
                        startIcon={<Icon name="close2" />}
                        sx={{
                          textTransform: "none",
                          color: COLORS.ERROR,
                          fontWeight: 500,
                        }}
                        disabled={saving}
                      >
                        Cancel
                      </Button>

                      <Button
                        startIcon={saving ? <CircularProgress size={16} color="inherit" /> : <Icon name={editingEntryId ? "check" : "plus2"} />}
                        sx={{
                          backgroundColor: COLORS.SECONDARY,
                          color: "#fff",
                          textTransform: "none",
                          px: 2.5,
                          "&:hover": {
                            backgroundColor: COLORS.SECONDARY,
                          },
                          "&:disabled": {
                            backgroundColor: COLORS.LIGHT_SECONDARY,
                          }
                        }}
                        onClick={handleAddEntry}
                        disabled={saving}
                      >
                        {saving ? (editingEntryId ? "Updating..." : "Adding...") : (editingEntryId ? "Update Entry" : "Add New Entry")}
                      </Button>
                    </Box>
                  </Box>
                )}

                {/* ADD BUTTON (only show if not in add/edit mode) */}
                {/* {activeDay !== dayBlock.formattedDate && (
                  <FlexEnd mt={1}>
                    <Button
                      size="small"
                      startIcon={<Icon name="plus2" />}
                      sx={{
                        backgroundColor: COLORS.SECONDARY,
                        color: "#fff",
                        textTransform: "none",
                      }}
                      onClick={() => {
                        setActiveDay(dayBlock.formattedDate);
                        setEditingEntryId(null);
                        setNewEntry({
                          targetedActivity: "",
                          contractorVendor: "",
                          details: "",
                          materialMachineryRequirements: "",
                          supportNeeded: "",
                          remarks: "",
                        });
                      }}
                      disabled={!weekStartDate}
                    >
                      Add New Entry
                    </Button>
                  </FlexEnd>
                )} */}

                {/* SINGLE DAY SEPARATOR */}
                <Box
                  mt={2}
                  height="1px"
                  sx={{ backgroundColor: COLORS.LIGHT_SECONDARY }}
                />
              </Box>
            ))}

            {/* SAVE/UPDATE BUTTON */}
            <Box display="flex" justifyContent="center" mt={3}>
              <Button
                variant="contained"
                size="large"
                startIcon={<Icon name="save" />}
                sx={{
                  backgroundColor: COLORS.PRIMARY,
                  color: "#fff",
                  textTransform: "none",
                  px: 4,
                  "&:hover": {
                    backgroundColor: COLORS.SECONDARY,
                  },
                }}
                onClick={handleSaveWPR}
                disabled={saving}
              >
                {saving ? "Saving..." : "Update Weekly Report"}
              </Button>
            </Box>
          </>
        )}

        {/* Date Picker Dialog */}
        <Dialog open={showDatePicker} onClose={() => setShowDatePicker(false)}>
          <DialogTitle>Select Week Start Date (Monday)</DialogTitle>
          <DialogContent>
            <DatePicker
              value={weekStartDate}
              onChange={handleWeekDateSelect}
              openTo="day"
              views={['year', 'month', 'day']}
              renderInput={(params) => (
                <TextField 
                  {...params} 
                  fullWidth 
                  sx={{ mt: 2, display: 'none' }} 
                  InputProps={{
                    ...params.InputProps,
                    readOnly: true,
                  }}
                />
              )}
              shouldDisableDate={(date) => {
                // Only allow Mondays to be selected
                return date.getDay() !== 1;
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowDatePicker(false)}>Cancel</Button>
          </DialogActions>
        </Dialog>

        {/* DELETE CONFIRMATION DIALOG */}
        <Dialog
          open={deleteDialog.open}
          onClose={() => setDeleteDialog({ open: false, entryId: null, dayIndex: null, entryIndex: null })}
        >
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <Typography>Are you sure you want to delete this entry?</Typography>
          </DialogContent>
          <DialogActions>
            <Button 
              onClick={() => setDeleteDialog({ open: false, entryId: null, dayIndex: null, entryIndex: null })}
              disabled={saving}
            >
              Cancel
            </Button>
            <Button 
              onClick={handleDeleteEntry}
              color="error"
              disabled={saving}
            >
              {saving ? "Deleting..." : "Delete"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Toast Component */}
        <AppToast
          open={toast.open}
          type={toast.type}
          title={toast.title}
          message={toast.message}
          onClose={closeToast}
        />
      </Box>
    </LocalizationProvider>
  );
}

/* ================= REUSABLE COMPONENTS ================= */

const FlexRow = ({ children, header }) => (
  <Box
    display="flex"
    alignItems="stretch"
    sx={{
      py: header ? 1.2 : 1,
      fontWeight: header ? 600 : 400,
    }}
  >
    {children}
  </Box>
);

const FlexCell = ({ children, flex, w, sx = {}, borderBottom = "none", ...props }) => (
  <Box 
    flex={flex} 
    width={w} 
    px={1} 
    sx={{ 
      ...TYPOGRAPHY.BODY_LARGE,
      borderBottom: borderBottom,
      ...sx
    }}
    {...props}
  >
    {children}
  </Box>
);

const FlexRowInner = ({ children, header, isLastEntry = false }) => (
  <Box
    display="flex"
    flex={1}
    alignItems="stretch"
    sx={{
      borderBottom: isLastEntry ? 'none' : `1px solid ${COLORS.LIGHT_SECONDARY}`,
    }}
  >
    {children}
  </Box>
);

const FlexEnd = ({ children, mt }) => (
  <Box display="flex" justifyContent="flex-end" mt={mt}>
    {children}
  </Box>
);

const Field = ({ label, sx = {}, ...props }) => (
  <Box display="flex" flexDirection="column" flex={1}>
    <Typography
      sx={{
        fontSize: "12px",
        fontWeight: 500,
        color: COLORS.SECONDARY,
        mb: 0.5,
      }}
    >
      {label}
    </Typography>

    <TextField
      fullWidth
      variant="outlined"
      {...props}
      sx={{
        "& .MuiOutlinedInput-root": {
          height: props.multiline ? "auto" : "40px",
          borderRadius: "6px",
          fontSize: "13px",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: COLORS.LIGHT_SECONDARY,
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: COLORS.SECONDARY,
        },
        "& .MuiInputBase-input::placeholder": {
          color: COLORS.LIGHT_SECONDARY,
          opacity: 1,
          fontSize: "13px",
        },
        ...sx,
      }}
    />
  </Box>
);